<template>
  <div class="integral-record">
    <Header :title="title" :goBackHandler="goBack"></Header>
    <fixed-tab>
      <van-tabs slot="content" :line-width="16" :line-height="2" v-model="curTab">
        <van-tab v-for="(item, index) in tabs" :key="index" :title="item.name" :name="item.id"></van-tab>
      </van-tabs>
    </fixed-tab>
    <Empty v-if="!list.length" style="margin-top:10.66667vw;" :empty_type="{ name: '暂无记录' }"></Empty>
    <List
      ref="list"
      url="/api/app/user/integral/order"
      method="get"
      :params="params"
      :on-getdata="onGetdata"
      :on-formatter="onFormatter"
      :showText="list.length > 0"
    >
      <div class="card-wrap" slot="item">
        <div class="card" v-for="(item, index) in list" :key="index" @click="goDetail(item)">
          <div class="head">
            <span class="time">
              兑换时间：{{
              item.created_at | fomartTime("yyyy/MM/dd hh:mm:ss")
              }}
            </span>
            <span class="status">{{ getStatusName(item) }}</span>
          </div>
          <div class="body">
            <div class="book" v-if="item.shop_type == 12">
              <img class="cover" :src="item.cover_img" />
              <div class="info">
                <p class="title">{{ item.product_name }}</p>
                <div class="bottom">
                  <p class="point-box">
                    <span class="point">{{ item.product_price }}</span>
                    <span class="tag">{{point_name}}</span>
                  </p>
                  <div class="btn-box" v-if="item.order_status != 2 && item.ship_status == 3">
                    <p class="btn" @click.stop="onLogisticsDetail(item)">物流详情</p>
                    <p class="btn" @click.stop="onConfirmShip(item)">确认收货</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="course" v-else>
              <img class="cover" :src="item.cover_img" />
              <div class="info">
                <p class="title">{{ item.product_name }}</p>
                <div class="bottom">
                  <p class="point-box">
                    <span class="point">{{ item.product_price }}</span>
                    <span class="tag">{{point_name}}</span>
                  </p>
                  <div class="btn-box">
                    <p class="btn" v-if="!item.is_join_study" @click.stop="onJoinStudy(item)">加入学习</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </List>
    <van-dialog
      class="logistice-dlg"
      v-model="dlgLogistics.show"
      show-confirm-button
      show-cancel-button
      confirm-button-text="复制单号"
      @confirm="onCopyLogistics"
    >
      <p>快递公司：{{ dlgLogistics.logistics_name }}</p>
      <p>快递单号：{{ dlgLogistics.logistics_number }}</p>
    </van-dialog>
    <van-dialog
      v-model="dlgComfirmShip.show"
      show-confirm-button
      show-cancel-button
      @confirm="onOkConfirmShip()"
    >
      <p>确认收货后，订单将会完成，是否确认？</p>
    </van-dialog>
  </div>
</template>

<script>
import Empty from "@/components/Empty";
import Header from "@/components/Header";
import List from "@/components/List";
import ClipboardJS from "clipboard";
export default {
  name: "integral-record",
  components: {
    Empty,
    Header,
    List
  },
  computed: {
    point_name() {
      if( this.$store.state.config ) {
        return this.$store.state.config.point_info.point_name;
      }else{
        return '';
      }
    }
  },
  data() {
    return {
      title:{
        name:'兑换记录'
      },
      tabs: [
        { id: 0, name: "全部" },
        { id: 1, name: "待发货" },
        { id: 2, name: "已发货" },
        { id: 3, name: "已完成" }
      ],
      curTab: 0,
      list: [],
      params: {
        status: 0
      },
      dlgLogistics: {
        show: false,
        logistics_name: "",
        logistics_number: ""
      },
      dlgComfirmShip: {
        show: false,
        order_id: 0
      }
    };
  },
  watch: {
    curTab(val) {
      this.params.status = val;
      this.requestList();
    }
  },
  mounted() {
    this.initClipbord();
  },
  methods: {
    goBack () {
     this.$router.go(-1);
    },
    // on event
    onGetdata(data) {
      this.list = data;
    },
    onFormatter(data) {
      data.forEach(i => {
        i.product_price = (i.product_price / 100).toFixed(0);
      });
    },
    onLogisticsDetail(item) {
      this.dlgLogistics.show = true;
      this.dlgLogistics.logistics_name = item.logistics_name;
      this.dlgLogistics.logistics_number = item.logistics_number;
    },
    onConfirmShip(item) {
      this.dlgComfirmShip.show = true;
      this.dlgComfirmShip.order_id = item.order_id;
    },
    onCopyLogistics() {
      // console.log("onCopyLogistics");
      this.$toast("复制成功");
    },
    onOkConfirmShip() {
      this.$http
        .put(`/api/app/orderShip/confirm/${this.dlgComfirmShip.order_id}`)
        .then(() => {
          this.requestList();
        });
    },
   async onJoinStudy(item) {
     await this.$http
        .post("/api/app/joinStudy", {
          order_id: item.order_id,
          join_from: 2,
          course_type: item.shop_type
        })
        .then(() => {
          this.$dialog.alert({
            title: "提示",
            message: "课程成功加入学习列表。您可在“我的学习”中进行课程学习。"
          });
        });
      this.requestList();
    },
    // other
    initClipbord() {
      const that = this;
      new ClipboardJS(".logistice-dlg .van-dialog__confirm", {
        text: function() {
          return that.dlgLogistics.logistics_number || " ";
        }
      });
      // clipboard.on("success", function(e) {
      //   console.log(e);
      // });
      // clipboard.on("error", function(e) {
      //   console.log(e);
      // });
    },
    getStatusName(item) {
      if (item.order_status == 2) {
        return "已完成";
      }
      if (item.shop_type == 12) {
        switch (item.ship_status) {
          case 1:
            return "待发货";
          case 3:
            return "已发货";
        }
      }
      return "";
    },
    // request
    requestList() {
      this.$refs.list.reset();
    },
    goDetail(item){
      this.$router.push({
        name: "OrderDetail",
        query: {
          order_id: item.order_id,
          order_type: item.shop_type
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.integral-record {
  /deep/{
    .fixed-tab > div{
      top: 88px;
      .van-tabs--line .van-tabs__wrap{
        border:none;
      }
    }
  }
  .card-wrap {
    padding: 30px 20px;
    .card {
      padding: 24px;
      margin-bottom: 20px;
      border-radius: 18px;
      box-shadow: 0 0 26px -4px rgba(0, 0, 0, 0.1);
      .head {
        font-size: 22px;
        display: flex;
        justify-content: space-between;
        position: relative;
        padding-bottom: 24px;
        .time {
          color: #595959;
        }
        .status {
          color: #ea7a2f;
        }
        &::after {
          content: "";
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 2px;
          background-color: #f5f5f5;
        }
      }
      .body {
        margin-top: 22px;
        .book {
          display: flex;
        }
        .course {
          display: flex;
          .cover {
            width: 270px;
            height: 158px;
          }
        }
        .cover {
          flex: none;
          width: 132px;
          height: 184px;
          margin-right: 24px;
          border-radius: 20px;
        }
        .info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title {
            color: rgba(0, 0, 0, 0.85);
            font-size: 28px;
            line-height: 48px;
          }
          .bottom {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            .point-box {
              color: #ee1f1f;
              .point {
                font-size: 32px;
              }
              .tag {
                font-size: 24px;
              }
            }
            .btn-box {
              .btn {
                display: inline-block;
                color: #595959;
                font-size: 24px;
                padding: 0 28px;
                border: 1px solid #d9d9d9;
                border-radius: 28px;
                height: 56px;
                line-height: 56px;
                margin-left: 20px;
                &:last-child {
                  border: 1px solid #ea7a2f;
                  color: #ea7a2f;
                }
              }
            }
          }
        }
      }
    }
  }
  /deep/ .van-dialog {
    .van-dialog__content {
      text-align: center;
      padding: 34px 30px;
      color: #595959;
      font-size: 30px;
      line-height: 48px;
    }
    .van-button {
      font-size: 30px;
    }
    .van-button.van-dialog__confirm {
      background-color: #fff;
      color: $theme_color;
    }
  }
}
</style>
